export const defaultPaginator = {
  pageIndex: 0,
  pageSize: 25,
  pageSizeOptions: [10, 25, 50],
};
